module.exports = __webpack_public_path__ + "static/img/scroll_pizza_2.8f807c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/scroll_pizza_2.png
// module id = S4yd
// module chunks = 0